export default "__VITE_ASSET__BvxW4DXo__"